export const faqs = [
  {
    q: "131吃瓜 上的证据是怎么整理的？",
    a: "每条素材都会先登记原始出处与发布时间，再按截图证据、录音证据、文字记录等类型归档，并单独拉一条时间线，方便对照同一方在不同时间点的说法变化。",
  },
  {
    q: "素材会标注来源吗？",
    a: "会。截图、录音与录屏都会尽量保留账号名、发布时间或原始链接；无法确认出处的素材会明确标注为待核实，不会直接当作实锤展示。",
  },
  {
    q: "为什么有的条目写着「待核实」？",
    a: "当素材缺少原始出处、存在明显剪辑痕迹，或与已知时间线冲突时，会先标记为待核实。这样做的目的是把猜测和证据分开，避免误伤。",
  },
  {
    q: "证据合集多久更新一次？",
    a: "热门事件通常每日更新，普通事件按素材到齐节奏更新。页面右上角会显示该事件最后一次整理时间，方便判断材料新旧。",
  },
  {
    q: "我可以提交线索或补充素材吗？",
    a: "可以。在「关于我们」页面底部有线索提交入口，请尽量附上原始链接与大致时间，我们会先做来源核对再决定是否收录。",
  },
  {
    q: "整理的内容会不会偏袒某一方？",
    a: "收录原则是「只放可核对的材料，不替任何一方下结论」。如果同一事件存在多种说法，会并列呈现，并标注各自的出处。",
  },
];